const DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const PDF = 'application/pdf';
const HTML = 'text/html';

const documentTypes = {
  docx: DOCX,
  pdf: PDF,
  html: HTML,
};

export { DOCX, PDF, HTML, documentTypes };
